import { Button } from "@/components/ui/button";
import { Reply, X } from "lucide-react";
import PropTypes from "prop-types";

/**
 * ReplyContextBar - Shows which message the user is replying to
 * Appears above the chat input when a reply is active
 *
 * @component
 * @example
 * <ReplyContextBar
 *   replyToMessage={{ id: 'msg-1', role: 'user', content: 'Hello' }}
 *   onDismiss={() => cancelReplyToMessage()}
 * />
 */
export function ReplyContextBar({ replyToMessage, onDismiss }) {
  if (!replyToMessage) return null;

  const authorLabel = replyToMessage.role === "user" ? "You" : "Assistant";
  const preview = replyToMessage.content?.substring(0, 100) || "";

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-muted/50 border-l-4 border-primary">
      <Reply className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-xs font-medium text-foreground">
          Replying to {authorLabel}
        </div>
        <div className="text-xs text-muted-foreground truncate">{preview}</div>
      </div>
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6 flex-shrink-0"
        onClick={onDismiss}
      >
        <X className="h-3 w-3" />
      </Button>
    </div>
  );
}

ReplyContextBar.propTypes = {
  replyToMessage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    content: PropTypes.string,
  }),
  onDismiss: PropTypes.func.isRequired,
};
